// extracted by mini-css-extract-plugin
export default {"link":"Link_link__eh27j","active":"Link_active__BbF9f"};